import React from 'react';
import { Collapse, List, Progress, Tag, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { truncate } from '../services';
import type { LLMAnswer } from '../models';

const { Text } = Typography;

interface LLMSourcesPanelProps {
  llmAnswers: LLMAnswer[];
}

const LLMSourcesPanel: React.FC<LLMSourcesPanelProps> = ({ llmAnswers }) => {
  const sources = (llmAnswers ?? []).filter(
    (a) =>
      a.source_type === 'vector' ||
      a.source_type === 'mixed' ||
      a.answer_type === 'vector_result'
  );

  if (sources.length === 0) return null;

  return (
    <Collapse
      className="mb-4"
      ghost={false}
      items={[
        {
          key: 'sources',
          label: (
            <span className="flex items-center gap-2 font-medium text-gray-700">
              <FileTextOutlined />
              參考來源
              <Tag color="blue" className="ml-1">
                {sources.length} 筆
              </Tag>
            </span>
          ),
          children: (
            <List
              dataSource={sources}
              split
              renderItem={(source, index) => {
                const percent = Math.round(
                  Math.min(Math.max(source.confidence || 0, 0), 1) * 100
                );
                const progressColor =
                  percent >= 80
                    ? '#52c41a'
                    : percent >= 60
                      ? '#1677ff'
                      : '#faad14';

                return (
                  <List.Item key={source.id || index} className="px-0">
                    <div className="w-full">
                      <div className="flex items-center justify-between mb-1">
                        <Text strong className="text-sm text-gray-800">
                          {source.source_type === 'vector'
                            ? `向量來源 ${index + 1}`
                            : `來源 ${index + 1}`}
                        </Text>
                        <div className="flex items-center gap-2 ml-4 flex-shrink-0">
                          <Text type="secondary" className="text-xs">
                            信心度
                          </Text>
                          <Progress
                            type="circle"
                            size={40}
                            percent={percent}
                            strokeColor={progressColor}
                            format={(p) => (
                              <span
                                style={{ fontSize: '10px', fontWeight: 600 }}
                              >
                                {p}%
                              </span>
                            )}
                          />
                        </div>
                      </div>
                      <Text
                        type="secondary"
                        className="text-sm"
                        style={{
                          display: 'block',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.6',
                        }}
                      >
                        {truncate(source.answer_content, 300)}
                      </Text>
                    </div>
                  </List.Item>
                );
              }}
            />
          ),
        },
      ]}
    />
  );
};

export default LLMSourcesPanel;
